import { Paper } from "@material-ui/core";
import { Sync } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { HttpClient } from "../../../web-services/http-client";
import { IParkingLotsMapData } from "../../../web-services/models/parking-lots-map-data";
import { ParkingLotsMap } from "../../common/parking-lots-map";
import { ProgressDialog } from "../../common/progress-dialog";
import {VjtsMap} from "../../common/vjt-map";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function VjtMapPage(props: { httpClient: HttpClient })
{
    // TODO: get this data from backend.
    const [progressDialogOpened, setProgressDialogOpened] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>();
    const [errorCategoryMsg, setErrorCategoryMsg] = useState<string>();
    const [mapData, setMapData] = useState<IParkingLotsMapData[]>([]);
    const [isSendingRequest, setIsSendingRequest] = useState<boolean>(true);

    useEffect(() =>
    {
        if (!isSendingRequest) return;

        setProgressDialogOpened(true);

        const fetchData = async () =>
        {
            // Tabula rasa at the beginning.
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);

            try
            {
                let data = (await props.httpClient.get<IParkingLotsMapData[]>("vjt/get-map-data", "", 15000)).data;
                setMapData(data || []);
                setProgressDialogOpened(false);
            }
            catch (err: any)
            {
                console.log(err);

                // Check for generic error message in case of backend being down for example.
                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra az adatlekérést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }

            setIsSendingRequest(false);
        };

        fetchData().catch(console.error);

    }, [isSendingRequest]);

    return (
        <div className="scrollable-container">
            <ProgressDialog
                text="Adatlekérés folyamatban"
                retryButtonText="Újra lekérem"
                onRetryButtonClick={() => setIsSendingRequest(true)}
                onCancelButtonClick={() => setProgressDialogOpened(false)}
                retryButtonIcon={<Sync />}
                errorText={errorMsg}
                errorCategoryText={errorCategoryMsg}
                open={progressDialogOpened}
            />
            <Paper className="main-paper">
                <VjtsMap data={mapData} />
            </Paper>
        </div>
    );
}
